<ion-content>
	<div class="quickLogger-logo" [ngClass]="{ ios: platform === platformName.IOS }">
		<ion-img src="./../../../../assets/icon/quickLogger-logo.png" alt="QuickLogger logo"></ion-img>
	</div>
	<div class="content">
		<div class="back-button" (click)="goBack()"><ion-icon class="icon-Arrow-Left"></ion-icon></div>
		<div class="form">
			<form
				[formGroup]="noApiModeForm"
				role="form"
				(ngSubmit)="onSubmit(usernameControl.value)"
				autocomplete="off"
			>
				<ion-item class="fusion-version">
					<div>
						<span>{{ 'noApiMode.content' | translate }}</span>
					</div>
				</ion-item>
				<ng-container>
					<ion-item class="label">
						<ion-label>{{ 'login.username' | translate }}</ion-label>
					</ion-item>
					<ion-item>
						<ion-input formControlName="usernameControl" type="text"></ion-input>
					</ion-item>
				</ng-container>
				<ion-item>
					<button type="submit" [ngClass]="{ disabled: !usernameControl.valid }">
						{{ 'noApiMode.buttons.submit' | translate }}
					</button>
				</ion-item>
			</form>
		</div>
	</div>
	<div class="datamine-logo">
		<ion-img src="./../../../../assets/icon/datamine-logo.png" alt="Datamine logo"></ion-img>
	</div>
</ion-content>
